import { Injectable } from "@angular/core";
import { ViewReport } from "../inspection/inspection-data-manage.service";

@Injectable({
  providedIn: "root"
})
export class SelectReportService {
  public viewReport: ViewReport;

  constructor() {}

  setViewReport(id: string, version: number) {
    this.viewReport = new ViewReport(id, version);
  }

  getViewReport(): ViewReport {
    return this.viewReport;
  }
}
